import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import AccessArrangementReportDetails from '../../modules/admin/components/AccessArrangementReportDetails';

const AccessArrangementReport = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('admin->>AccessArrangementReport.AccessArrangementReport')} />

      <AccessArrangementReportDetails />
    </>
  );
};

export default AccessArrangementReport;
